import type { PainelVariant } from '@lume/shared/worklist';

export function PulsoBand({
  variant,
  queueCount,
  byMode,
}: {
  variant: PainelVariant;
  queueCount: number;
  byMode: { h_a: number; h_b: number; h_c: number };
}): JSX.Element {
  const human = byMode.h_a + byMode.h_b;
  const ai = byMode.h_c;
  const total = human + ai;
  const humanPct = total > 0 ? Math.round((human / total) * 100) : 0;
  // P0 (kickoff 2026-07-10): sem repetir o número — "7 · 7 aguardam você" não se lia.
  // N2-01 (05/Set/2026): `queueCount` é `tabs.awaitingMe` — TUDO o que está atribuído e
  // vivo, inclusive o que espera o CLIENTE. «aguardando sua ação» rotulava errado; a copy
  // passa a dizer o que o número mede (a mesma da sidebar: «atribuídas e ativas»).
  const qualifier = queueCount === 0 ? 'fluxo calmo' : 'atribuídas e ativas';
  return (
    <div className="pulso">
      <div className="pulso__top">
        <div className="vital">
          <span className="k">na sua fila</span>
          <span className="v">
            {queueCount} <small>· {qualifier}</small>
          </span>
        </div>
        {total > 0 && (
          <div className="balance">
            <div className="balance__bar">
              {human > 0 && <span className="balance__h" style={{ width: `${humanPct}%` }} />}
              {ai > 0 && <span className="balance__ai" style={{ width: `${100 - humanPct}%` }} />}
            </div>
            <div className="balance__legend">
              {variant === 'solo'
                ? 'você · a IA cobre o resto'
                : [human > 0 ? `${human} com você` : null, ai > 0 ? `${ai} com a IA` : null]
                    .filter(Boolean)
                    .join(' · ')}
            </div>
          </div>
        )}
      </div>
      {/* spark + event ribbon: honest-defer (Fatia 2 / Fatia 4) */}
    </div>
  );
}
